import { FormikProps } from 'formik';
import moment from 'moment';
import addPathPrefix from 'utils/addPathPrefix';
import { formatDateTimeToISO8601UTCTimestamp } from '../utils';

type Options = {
    /**
     * Clearing the date drops the whole `{ dateTime }` wrapper instead of emptying the child.
     * Writing only the child leaves `{ dateTime: null }` behind, and that empty wrapper fails the
     * wrapper's required check even where the message structure marks the date optional - with no
     * way to clear it from the form.
     */
    optional?: boolean;
};

/**
 * Date-times are held in a `{ dateTime }` wrapper at `path`.
 *
 * The form does not validate on change, and the clear button of a date picker does not blur it, so
 * the messages of the previous run would stay on screen over a date that was just cleared until the
 * user clicked into the field and out of it again. The change is therefore written with validation,
 * and the field is marked touched - without a run of its own - so that what it reports is shown.
 */
const onDateTimeChange =
    (formik: FormikProps<any>, path: string, { optional = false }: Options = {}) =>
    (value: moment.Moment | null) => {
        const dateTime = formatDateTimeToISO8601UTCTimestamp(value);
        const dateTimePath = addPathPrefix(path, 'dateTime');

        formik.setFieldTouched(dateTimePath, true, false);

        if (optional && dateTime === null) {
            formik.setFieldValue(path, null, true);
            return;
        }

        formik.setFieldValue(dateTimePath, dateTime, true);
    };

export default onDateTimeChange;
